import { Component, Inject, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/_services';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormControl, Validators, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { TranslateHelper } from '@app/_helpers';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { RegisterComponent } from './componenet/register/register.component';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    providers: [TranslateHelper, BsModalRef],
    standalone: true,
    imports: [FlexModule, IconComponent, NgIf, FormsModule, ReactiveFormsModule, RouterLink, RegisterComponent, TranslateModule]
})
export class LoginDialogComponent implements OnInit {

    constructor(//public bsModalRef: BsModalRef,
        public dialogref: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private authService: AuthenticationService,
        private fb: UntypedFormBuilder,
        private translateHelper: TranslateHelper,
        private toastr: ToastrService) { }
    email;
    form = this.fb.group({
        email: [null, [Validators.required, Validators.email]],
        password: [null, Validators.required]
    });
    submitted = false;
    register = false;
    ngOnInit(): void {
        if (this.data?.email) this.email = this.data?.email;
        this.form.get('email').setValue(this.email);
    }

    login() {
        this.submitted = true;
        if (this.form.invalid) return;
        this.authService.login(this.form.value).subscribe((user) => {
            if (user.code == 400) {
                this.toastr.error(this.translateHelper.getTranslation("err_name_password") || "Cannot loggin");
                return;
            }

            if (_.isEmpty(user.data)) {
                this.toastr.error("Cannot login");
                return;
            }
            //this.bsModalRef.hide();
            this.dialogref.close(true);
            this.toastr.success(`Welcome Back ${user.data.name}`);
        }, (error) => {
            this.toastr.error(this.translateHelper.getTranslation("err_name_password"));
        });
    }

    loginForm() { this.register = false; }

}
